import { Button } from '@kcftech/design-system';
import { FormEvent, ReactNode, Ref } from 'react';
import styled from 'styled-components';
import { borderColor } from 'styles/theme';

const ContentForm = styled.form`
    position: relative;
    height: 100%;
    inset: 0;
    display: grid;
    grid-template-rows: 1fr auto;
`;

const Content = styled.div`
    position: relative;
    margin: 0 3rem 0 3rem;
`;

const ScrollableContent = styled.div`
    position: absolute;
    inset: 0;
    overflow-y: auto;
    height: 100%;
    padding-top: 3rem;
    padding-bottom: 1rem;
`;

const ButtonBar = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 3rem;
    * + * {
        margin-left: 1rem;
    }
    box-sizing: border-box;
    border-top: 1px solid ${borderColor};
`;

export type WizardContentProps = Readonly<
    {
        cancelButtonRef?: Ref<HTMLDivElement>;
        nextButtonLabel?: string;
        canCancel?: boolean;
        onBack?: () => void;
        onCancel?: () => void;
        children?: ReactNode;
    } & (
        | {
              canProceed: boolean;
              onNext: () => void;
          }
        | {
              canProceed: false;
              onNext?: () => void;
          }
    )
>;

export function WizardContent({
    cancelButtonRef,
    nextButtonLabel = 'Next',
    canCancel = true,
    canProceed,
    onBack,

    onNext = () => {},
    onCancel,
    children,
}: WizardContentProps) {
    const onSubmit = (event: FormEvent) => {
        event.preventDefault();
        onNext();
    };

    return (
        <ContentForm noValidate onSubmit={onSubmit}>
            <Content>
                <ScrollableContent>{children}</ScrollableContent>
            </Content>
            <ButtonBar>
                {onCancel && (
                    <div ref={cancelButtonRef}>
                        <Button
                            type="button"
                            appearance="secondary"
                            disabled={!canCancel}
                            onClick={() => onCancel()}
                        >
                            Cancel
                        </Button>
                    </div>
                )}
                {onBack && (
                    <Button
                        type="button"
                        appearance="secondary"
                        disabled={!canCancel}
                        onClick={onBack}
                    >
                        Back
                    </Button>
                )}
                <Button type="submit" appearance="primary" disabled={!canProceed}>
                    {nextButtonLabel}
                </Button>
            </ButtonBar>
        </ContentForm>
    );
}
